import { create } from 'zustand'

const STORAGE_KEY = 'chart_access_token'
const PASSWORD_KEY = 'chart_password_session'

// El password se guarda solo en sessionStorage (no persiste al cerrar pestaña)
// para poder re-hacer login automático cuando el JWT caduca (401). El JWT de
// chart es corto (~24h) y no hay refresh token dedicado.
const useChartAuthStore = create((set) => ({
  token: localStorage.getItem(STORAGE_KEY),
  username: localStorage.getItem('chart_username'),
  password: sessionStorage.getItem(PASSWORD_KEY) || null,

  // Paso intermedio de 2FA (temp_token de /login o enroll_token de
  // force_enrollment) — deliberadamente solo en memoria (ni localStorage ni
  // sessionStorage): vive 5-15 min, no debe sobrevivir a un refresh de
  // página, y no aporta nada persistirlo (es de un solo uso).
  pending: null, // { token, username, kind: '2fa' | 'enroll', password? } | null

  // null = todavía no se ha resuelto GET /auth/me (ver ChartAuthGate) --
  // deliberadamente distinto de `false` para que el icono de Agentes en la
  // toolbar y el gate de #agentes no parpadeen mostrando "sin acceso" antes
  // de conocer el flag real. Nunca persistido: se re-resuelve en cada sesión.
  agentsEnabled: null,

  // Mismo tri-estado que agentsEnabled, para el gate de la ruta #analisis
  // (análisis no tiene icono en la toolbar -- decisión de diseño: solo se
  // entra desde la web). null = /auth/me aún no ha resuelto; nunca
  // persistido, se re-resuelve en cada sesión.
  dailyAnalysisEnabled: null,

  // `password` solo se adjunta en kind='enroll': el formulario de
  // enrollment forzado lo necesita para /2fa/setup y /2fa/verify (current_
  // password) sin volver a pedirlo justo después de haberlo escrito en el
  // login. Nunca se persiste (ni aquí ni en el estado 'enroll').
  setPending: (token, username, kind, password) => set({ pending: { token, username, kind, password } }),
  clearPending: () => set({ pending: null }),

  setAgentsEnabled: (value) => set({ agentsEnabled: value }),
  setDailyAnalysisEnabled: (value) => set({ dailyAnalysisEnabled: value }),

  setSession: (token, username, password) => {
    localStorage.setItem(STORAGE_KEY, token)
    if (username) localStorage.setItem('chart_username', username)
    if (password) sessionStorage.setItem(PASSWORD_KEY, password)
    set({ token, username, password: password || null, pending: null, agentsEnabled: null, dailyAnalysisEnabled: null })
  },
  // Token de captura efímero del Análisis diario (scope='snapshot', TTL
  // ~5 min, un solo uso por captura — ver backend snapshot_token_service).
  // Llega por query param en /snapshot y SOLO vive en memoria: nunca en
  // localStorage/sessionStorage — es un token de servicio de un solo uso,
  // no una sesión, y no debe sobrevivir a la captura.
  setSnapshotToken: (token) => set({ token }),
  logout: () => {
    localStorage.removeItem(STORAGE_KEY)
    localStorage.removeItem('chart_username')
    sessionStorage.removeItem(PASSWORD_KEY)
    set({ token: null, username: null, password: null, pending: null, agentsEnabled: null, dailyAnalysisEnabled: null })
  },
}))

export default useChartAuthStore
export { STORAGE_KEY as CHART_TOKEN_STORAGE_KEY }
